/** Verified against Soon's factory, market and ledger on 2026-11-01. */
export const SNSC = {
  name: 'Soonscreener',
  symbol: 'SNSC',
  market: 'x6tu4-caaaa-aaaai-ayeuq-cai',
  ledger: 'xxq7a-uiaaa-aaaai-ayeva-cai',
  creator: '73ot2-q4kgx-bihfi-xw67d-ktnwy-bsgzj-zx3k7-3avlf-nzf3k-5xz3s-iae',
  factory: '3jz7z-jqaaa-aaaab-ag6kq-cai',
  baseLedger: 'ryjl3-tyaaa-aaaaa-aaaba-cai',
  mintSubaccountHex: '736f6f6e3a6d696e740000000000000000000000000000000000000000000000',
  tokenPath: '/token/x6tu4-caaaa-aaaai-ayeuq-cai',
  soonUrl: 'https://soonlaunchpad.fun/t/x6tu4-caaaa-aaaai-ayeuq-cai',
} as const;
